import { render, staticRenderFns } from "./ReplyList.vue?vue&type=template&id=0f982eba"
import script from "./ReplyList.vue?vue&type=script&lang=js"
export * from "./ReplyList.vue?vue&type=script&lang=js"
import style0 from "./ReplyList.vue?vue&type=style&index=0&id=0f982eba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports